/* pdp-tn-form-box: Tab-Umschalter der TN-Box (Einzelpersonen | Unternehmen), das
   Schließen-X im Unternehmen-Panel und die Höhen-Reservierung der Form-Spalte.
   Läuft nur, wenn pdp-hero die Tabs rendert. */
(function () {
  "use strict";

  var dialog = document.getElementById("TN-Form-Dialog");
  if (!dialog) return;

  var tabs = dialog.querySelectorAll("[data-tn-form-tab]");
  var panels = dialog.querySelectorAll("[data-tn-form-panel]");
  if (!tabs.length || !panels.length) return;

  var ACTIVE_TAB = "pdp-tn-form-box__tab--active";
  var ACTIVE_PANEL = "pdp-tn-form-box__panel--active";
  var INLINE_MIN_WIDTH = 1024;

  var formCol = dialog.closest(".pdp-hero__form-col");

  function activeKey() {
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].classList.contains(ACTIVE_TAB)) return tabs[i].dataset.tnFormTab;
    }
    return null;
  }

  function activate(key) {
    tabs.forEach(function (tab) {
      var isActive = tab.dataset.tnFormTab === key;
      tab.classList.toggle(ACTIVE_TAB, isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });
    panels.forEach(function (panel) {
      panel.classList.toggle(ACTIVE_PANEL, panel.dataset.tnFormPanel === key);
    });
  }

  // Ab 1024px liegt die Box im Flow und treibt die Hero-Höhe. Die Form-Spalte
  // bekommt die Höhe des höchsten Panels als min-height, damit die Section beim
  // Umschalten nicht springt, die Box selbst aber nur so hoch ist wie ihr Inhalt.
  // Die Panels werden synchron durchgeschaltet – ohne Paint dazwischen.
  function reserveHeight() {
    if (!formCol) return;
    if (window.innerWidth < INLINE_MIN_WIDTH || !dialog.open) {
      formCol.style.minHeight = "";
      return;
    }
    var current = activeKey();
    var max = 0;
    tabs.forEach(function (tab) {
      activate(tab.dataset.tnFormTab);
      max = Math.max(max, dialog.offsetHeight);
    });
    activate(current);
    formCol.style.minHeight = max ? max + "px" : "";
  }

  var frame = 0;
  function scheduleReserve() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = 0;
      reserveHeight();
    });
  }

  // stopPropagation: der Outside-Click-Handler des Dialogs (pdp-TN-Form-Dynamic-Options.js)
  // misst die Box erst nach dem Umschalten und würde den Klick sonst als „außerhalb" werten
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function (event) {
      event.stopPropagation();
      activate(tab.dataset.tnFormTab);
    });
  });

  dialog.querySelectorAll("[data-tn-form-close]").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.stopPropagation();
      dialog.close();
    });
  });

  if (formCol) {
    // pdp-TN-Form-Dynamic-Options.js öffnet den Dialog erst nach dem Laden (.show());
    // vorher ist offsetHeight 0
    new MutationObserver(scheduleReserve).observe(dialog, { attributes: true, attributeFilter: ["open"] });
    window.addEventListener("resize", scheduleReserve);
    window.addEventListener("load", scheduleReserve);
    scheduleReserve();
  }
})();
